import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import {NgxSpinnerService} from "ngx-spinner";
import {LoadingService} from "../../../shared/loading-service/loading.service";

@Injectable()
export class SpinnerInterceptor implements HttpInterceptor {
  private activeRequests = 0;


  constructor(private spinner: NgxSpinnerService,
              private loadingService:LoadingService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.activeRequests++;
    this.loadingService.setApiLoading(true)
    return next.handle(request).pipe(
        finalize(() => {
          this.activeRequests--;
          if (this.activeRequests === 0) {
            this.loadingService.setApiLoading(false)
          }
        })
    );
  }
}
